import React from 'react'
import PropTypes from 'prop-types'

/* doc
---
title: ModalCardHead
name: ModalCardHead
category: React - Bulma
---

A `ModalCardHead` component based on Bulma `.modal-card-head`. The header in ModalCard

This should be used with `ModalCard`

See [Bulma Documentation](http://bulma.io/documentation/components/modal/) for reference and full options.

```html_example
  <Modal>
    <ModalBackground />
    <ModalCard>
      <ModalCardHead>
        <ModalCardTitle>
          ...
        </ModalCardTitle>
      </ModalCardHead>
      <ModalCardBody>
        ...
      </ModalCardBody>
      <ModalCardFoot>
        ...
      </ModalCardFoot>
    </ModalCard>
  </Modal>
```
*/
function ModalCardHead(props) {
  const {
    className, children, onClose, ...rest
  } = props

  const classes = [
    'bulma-modal-card-head',
    className || '',
  ]

  return (
    <header {...rest} className={classes.join(' ')}>
      {children}
      <span className="bulma-delete" onClick={props.onClose} />
    </header>
  )
}

ModalCardHead.defaultProps = {
  onClose: null,
}

ModalCardHead.propTypes = {
  // The function for the close button
  onClose: PropTypes.func,
}

export default ModalCardHead
